<mat-toolbar color="primary">
  <mat-toolbar-row *ngIf="schedule.byOrderInfo.isByOrder == true">
    <h3>
      {{ schedule.type }}
      <mat-icon class="icon" [color]="getStatusColor(schedule)">{{ getStatusIcon(schedule) }}</mat-icon> <br />
    </h3>
  </mat-toolbar-row>

  <mat-toolbar-row *ngIf="schedule.byOrderInfo.isByOrder == false">
    <h3>
      {{ schedule.type }} - {{ timeFormat(schedule.plannedStartDate) }}
      <mat-icon class="icon" [color]="getStatusColor(schedule)">{{ getStatusIcon(schedule) }}</mat-icon>
    </h3>
  </mat-toolbar-row>

  <mat-toolbar-row *ngIf="schedule.byOrderInfo.isByOrder == true"
    >Atendimento a partir de: {{ schedule.byOrderInfo.startServiceHour | date: 'hh:mm' }} h</mat-toolbar-row
  >

  <mat-toolbar-row>
    <div *ngIf="schedule.practitioner && !isOrganizationDealer()">
      <b>Especialista:</b> {{ schedule.practitioner.name }}
    </div>
    <div *ngIf="schedule.practitioner && isOrganizationDealer()">
      <b>Clínica:</b> {{ schedule.organization.name }}
    </div>
    <div *ngIf="!schedule.practitioner && schedule.procedure">Procedimento: {{ schedule.procedure.name }}</div>
  </mat-toolbar-row>
  <mat-toolbar-row><b>Paciente:</b> {{ schedule.patient.name }}</mat-toolbar-row>
</mat-toolbar>
